import axios from "axios";
import { API_BASE_URL } from "../config";

export interface DiseaseOption {
  id: string;
  label: string;
}

export interface GetDiseaseOptionsParams {
  therapeuticArea: string;
  geneId?: string;
}

class DiseaseOptionsClient {
  private baseURL: string;

  constructor() {
    this.baseURL = API_BASE_URL;
  }

  /**
   * Fetch all available disease options
   * This endpoint should return a list of diseases formatted for the dropdown
   * @param params.therapeuticArea - The therapeutic area to filter by (e.g., 'cardiovascular', 'renal')
   * @param params.geneId - Optional gene symbol to filter diseases by. Only returns diseases where the gene is present.
   */
  async getDiseaseOptions(params: GetDiseaseOptionsParams): Promise<DiseaseOption[]> {
    try {
      // Build URL with query parameters
      const queryParams = new URLSearchParams();
      queryParams.append("therapeutic_area", params.therapeuticArea);
      queryParams.append("include_labels", "true");
      
      if (params.geneId) {
        queryParams.append("gene_id", params.geneId);
      }

      const url = `${this.baseURL}/api/tess/gene-explorer/diseases?${queryParams.toString()}`;
      
      // Try to fetch from the API
      const response = await axios.get(url);

      // API returns array of { id, label } objects
      return response.data.map((disease: { id: string; label: string }) => ({
        id: disease.id,
        label: disease.label,
      }));
    } catch (error) {
      console.error(
        "Failed to fetch disease options from API, using mock data:",
        error
      );
      throw error;
    }
  }
}

export const diseaseOptionsClient = new DiseaseOptionsClient();
